import { NavLink } from 'react-router-dom';

const AppSidebar = ({
  closeIcon,
  handleToggleSidebar,
  logo,
  menu,
  toggleSidebar,
}) => {
  return (
    <div
      className="btn p-0 menubar border-0 d-none d-lg-flex shadow-sm"
      id="main-menu"
    >
      <div className="menubar-header py-5 w-100 d-flex justify-content-center align-items-center">
        {toggleSidebar ? (
          <NavLink
            to="/"
            className="sidebar-logo"
            onClick={handleToggleSidebar}
          >
            <img alt="logo" src={logo} title="Kisahruang" />
          </NavLink>
        ) : (
          <button
            type="button"
            className="sidebar-logo"
            onClick={handleToggleSidebar}
          >
            <img alt="close-icon" src={closeIcon} />
          </button>
        )}
      </div>

      <div className="menubar-body d-flex justify-content-center w-100">
        <ul className="menu accordion">{menu()}</ul>
      </div>
    </div>
  );
};

export default AppSidebar;
